import React, { Component } from 'react';
import { Card, Icon, Popover, Table } from 'antd';
import { Link } from 'react-router';
import '../expenses.less';
import moment from 'moment';
import util from '@util/index';
import DescriptionList from '@comm/DescriptionList';
import ModalApportion from '@comm/apportion/ModalApportionShow';
import { queryFilePreview } from '@api/pub/attachment';
import { queryPaymentIncomepart } from '@api/finance/payment';
import { queryBudgetGroupCandF } from '@api/finance/budget';

const { Description } = DescriptionList;
const budgetType = ['部门预算', '跨部门预算', '项目预算组'];

class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      dataItem: this.props.data,
      isMore: false,
      pagination: {},
    };
  }

  componentDidMount() {
    const { dataItem } = this.state;
    !(+dataItem.budgetType === 1 || (dataItem.instance && dataItem.instance.status === 1)) &&
      this.getBudgetGroupCandF(dataItem.type);

    !(dataItem.instance && dataItem.instance.status === 1) &&
      this.paymentIncomepart(dataItem.incomepart, this.state.pagination);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
    if (nextProps.params.uuid !== this.props.params.uuid) {
      window.location.reload();
    }
  }

  findTypeName = type => {
    let typeName = '';
    this.props.expendType.forEach(item => {
      if (type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  getBudgetGroupCandF = (value, option) => {
    queryBudgetGroupCandF({
      type: value,
      userUuid: this.state.dataItem.createUser,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          groupTip: res.data,
        });
      }
    });
  };

  paymentIncomepart = (incomepart, pagination) => {
    const params = {
      incomepart,
      start: pagination.start || 0,
      limit: pagination.limit || 15,
    };
    const current = pagination.current || 1;
    const start = pagination.start || 0;
    queryPaymentIncomepart(params).then(res => {
      if (res.statusCode === 200) {
        if (this.state.isMore) {
          this.setState({
            inLongList: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: 15,
              current,
              start,
            },
          });
        } else {
          this.setState({
            inShortList: res.data.slice(0, 5),
            inLongList: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: 15,
              current,
              start,
            },
          });
        }
      }
    });
  };

  inExtra = () => {
    const { isMore, inShortList, inLongList } = this.state;
    if (inShortList && inLongList) {
      if (!isMore) {
        return (
          <Link onClick={this.getMore}>
            更多
            <Icon
              type="down"
              style={{
                fontSize: '10px',
                paddingLeft: '3px',
                position: 'relative',
                top: '-1px',
              }}
            />
          </Link>
        );
      }
      return (
        <Link onClick={this.getLess}>
          收起
          <Icon
            type="up"
            style={{
              fontSize: '10px',
              paddingLeft: '3px',
              position: 'relative',
              top: '-1px',
            }}
          />
        </Link>
      );
    }
    return null;
  };

  getMore = () => {
    this.setState({
      isMore: true,
    });
  };

  getLess = () => {
    this.setState({
      isMore: false,
    });
  };

  toPage = record => {
    this.props.router.push({
      pathname: `/finance/p_manage/open/${record.uuid}`,
    });
  };

  handleRejectVisible = flag => {};

  handleReturn = params => {
    this.props.doTask('return', params);
    this.handleRejectVisible(false);
  };

  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
      current: pagination.current,
    };
    const dataItem = this.props.data;
    this.paymentIncomepart(dataItem.incomepart, this.pagination);
  };

  columns = () => {
    return [
      {
        title: '流水编号',
        dataIndex: 'no',
        key: 'no',
        render: (text, record) => <Link onClick={() => this.toPage(record)}>{text}</Link>,
      },
      {
        title: '付款公司',
        dataIndex: 'company',
        key: 'company',
        render: (text, record) => {
          return <span>{text || '-'}</span>;
        },
      },
      {
        title: '金额',
        dataIndex: 'price',
        key: 'price',
        render: (text, record) => {
          return <span>{text ? util.numberFormat(text) : '-'}</span>;
        },
      },
      {
        title: '申请人',
        dataIndex: 'createUserName',
        key: 'createUserName',
        render: (text, record) => {
          return <span>{text || '-'}</span>;
        },
      },
      {
        title: '理由',
        dataIndex: 'reason',
        key: 'reason',
        render: text => {
          const content = <span>{text}</span>;
          return (
            <Popover content={content}>
              <p className="ellip">{text}</p>
            </Popover>
          );
        },
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          const a = moment.unix(text / 1000).format('YYYY-MM-DD');
          return <span>{a}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          const a = moment.unix(record.finishTime / 1000);
          const b = moment.unix(record.createTime / 1000);
          return (
            <span>
              {record.finishTime ? (
                <span>
                  {moment.unix(record.finishTime / 1000).format('YYYY-MM-DD')}
                  <span>(用时{a.diff(b, 'days')}天)</span>
                </span>
              ) : (
                ''
              )}
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { visible, dataItem, groupTip, isMore, inShortList, inLongList, pagination } = this.state;

    const files = dataItem.files || [];
    return (
      <div className="form-open">
        <Card title="付款详情">
          <DescriptionList size="large" col={3}>
            <Description term="付款类型">
              {this.findTypeName(dataItem.type)}
              <span className="lowspan">
                {groupTip && groupTip.groupName ? (
                  <span style={{ color: 'red' }}>
                    该费用类型,{groupTip.groupName}可用余额
                    <span>{groupTip.current || 0}</span>元
                    {groupTip.freeze ? (
                      <span>
                        , 冻结
                        <span>{groupTip.freeze || 0}</span>
                      </span>
                    ) : null}
                  </span>
                ) : null}
              </span>
            </Description>
            <Description term="付款金额">{dataItem.price}元</Description>
            <Description term="申请人员">{dataItem.createUserName}</Description>
            <Description term="预算来源">
              <a onClick={() => this.handleVisible(true)}>{budgetType[dataItem.budgetType]}</a>
            </Description>
            <Description term="付款公司">{dataItem.company}</Description>
            <Description term="收款方">{dataItem.incomepart}</Description>
            <Description term="收款方账户">{dataItem.account}</Description>
            <Description term="收款方开户行">{dataItem.bank}</Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="付款凭证">
              <div>
                {files.map(item => {
                  return (
                    <div key={item.uuid}>
                      <a onClick={() => queryFilePreview(item)}> {item.name}</a>
                    </div>
                  );
                })}
              </div>
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="付款说明">{dataItem.reason}</Description>
          </DescriptionList>

          {inShortList && inShortList.length > 0 ? (
            <div>
              <div style={{ color: 'red', textAlign: 'center', padding: '30px 0' }}>
                收款方历史收款记录{' '}
                <span style={{ color: '#1890FF', cursor: 'pointer' }}>{this.inExtra()}</span>
              </div>
              <Table
                columns={this.columns()}
                dataSource={isMore ? inLongList : inShortList}
                rowKey="uuid"
                pagination={isMore ? pagination : false}
                onChange={this.handleTableChange}
              />
            </div>
          ) : null}
        </Card>
        {visible ? (
          <ModalApportion
            onCancel={this.handleVisible}
            dataInfo={{}}
            dataItem={dataItem}
            visible={visible}
            onOk={this.handleOk}
            company={this.props.company}
            expendType={this.props.expendType}
          />
        ) : null}
      </div>
    );
  }
}

export default Open;



// WEBPACK FOOTER //
// ./src/components/finance/payment/FormOpen.js